import React from 'react'
import govImage from '../assets/Gov.png';
import ISB from '../assets/ISB-BIPP.png';
import Samagra from '../assets/Samagra.png';
import { Row } from 'reactstrap';
function Footer() {
  return (
    <div>
        <Row className='footer-main-row'>
            <img src={ISB} className='isb-image'/>
            <img src={govImage} className='gov-image'/>
            <img src={Samagra} className='isb-image'/>
        </Row>
       
        <center>

            <p className='powered-by-ncount'>Powered by <a style={{textDecoration:'none'}} href="https://ncount.in" target='_blank'><span style={{color:'#3e5f35',fontWeight:600}}>nCount</span></a></p>
        </center>
    </div>
  )
}

export default Footer